import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export enum EventNames {
  Cancel = 'cancel-booking',
  UpcomingTabLoaded = 'upcoming-tab-loaded',
  HistoryTabLoaded = 'history-tab-loaded',
  PageLoaded = 'page-loaded',
  WidgetInitialized = 'widget-initialized',
}

export class PanoramaLogger {
  constructor(private flowApi: ControllerFlowAPI) { }

  transactionStarted(eventName: EventNames) {
    this.flowApi?.panoramaClient?.transaction(eventName.toString()).start();
  }

  transactionEnded(eventName: EventNames) {
    this.flowApi?.panoramaClient?.transaction(eventName.toString()).finish();
  }
}
